module.exports = __webpack_public_path__ + "img/next2.1ad51779.jpg";